import { Typography, Grid, Box, Chip } from '@mui/material';
import { Nullable } from '@jamesgmarks/utilities';
import { ClientDropdown } from '../../../parts/ClientDropdown';
import { IClientDropdownItem } from '../../../../entity-interfaces/IClientDropdownItem';

interface ClientSelectionModeProps {
  selectedClient: Nullable<IClientDropdownItem>;
  onClientChanged: (client: Nullable<IClientDropdownItem>) => void;
}

export const ClientSelectionMode = ({ selectedClient, onClientChanged }: ClientSelectionModeProps) => {
  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Create credit notes for multiple subscriptions at once. Select a client to begin.
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <ClientDropdown
            clientId={selectedClient?.id ?? null}
            onClientChanged={onClientChanged}
          />
          {selectedClient && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Selected Client:
              </Typography>
              <Chip
                label={selectedClient.name}
                size="small"
                color="primary"
              />
            </Box>
          )}
        </Grid>
      </Grid>
    </>
  );
};
